import { render, staticRenderFns } from "./AllocationOnlineStockSingle.vue?vue&type=template&id=8bae4cce&scoped=true&"
import script from "./AllocationOnlineStockSingle.vue?vue&type=script&lang=js&"
export * from "./AllocationOnlineStockSingle.vue?vue&type=script&lang=js&"
import style0 from "./AllocationOnlineStockSingle.vue?vue&type=style&index=0&id=8bae4cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bae4cce",
  null
  
)

export default component.exports